import { Component } from "@angular/core";
import { NavParams, ViewController } from "ionic-angular";
import { PatientAllergy } from "pages/patient-chart/allergies/patient-allergies";
import { PatientAllergiesService } from "providers/patient-charts/patient-allergies-service";
import { ReferralsServiceProvider } from "providers/patient-charts/referrals-service";

@Component({
  selector: "allergies-popover",
  templateUrl: "allergies-popover.html",
})
export class AllergiesPopover {
  patientChartId: number;
  pageType: string = "";
  allergyLists = [];
  constructor(
    public allergySvc: PatientAllergiesService,
    public referralsService: ReferralsServiceProvider,
    public navParams: NavParams,
    public viewCtrl: ViewController
  ) {
    if (this.referralsService.PATIENT_STATUS) {
      this.pageType = this.referralsService.PATIENT_STATUS;
    }
    this.allergyLists = this.navParams.get("allergyLists");
    this.allergyLists.sort((a, b) => {
      if (!a.allergyType) return 1; // Move empty strings to the end
      if (!b.allergyType) return -1; // Move empty strings to the end
      return a.allergyType.localeCompare(b.allergyType);
    });
  }

  ionViewWillEnter(): void {}

  shouldShowAllergy = (allergy: PatientAllergy): boolean => !allergy.isDeleted;

  closeModal() {
    this.viewCtrl.dismiss({ cancel: true });
  }

  getReactionDisplay(patientAllergy: PatientAllergy) {
    if (patientAllergy.reactionOther) {
      return `Other - ${patientAllergy.reactionOther}`;
    }
    return patientAllergy.reaction;
  }
}



// WEBPACK FOOTER //
// ./src/navigation/components/allergies-popover/allergies-popover.ts